import React from "react";

interface TabsProps {
  tabs: Array<{
    label: string;
    value: string;
  }>;
  onChange: (value: string) => void;
  activeTab: string;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  onChange,
  activeTab,
  className,
}) => {
  return (
    <div className={className}>
      {tabs?.map((tab) => (
        <button
          className={`px-4 py-2 text-gray-500 hover:text-primary-600 hover:bg-gray-100 rounded-t-md text-sm border-b-2 ${
            activeTab === tab.value
              ? "text-primary-600 border-primary-600 font-semibold"
              : "border-transparent"
          }`}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
